import React, { useCallback, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { api, baseURL, customerReqConfig } from "../../include/api";
import {
  CANCELLED,
  DELIVERED,
  ERROR,
  ORDERED,
  PACKED,
  RETURN_APPROVED,
  RETURN_RECEIVED,
  RETURN_SHIPPED,
  SHIPPED,
  SUCCESS,
} from "../../include/constant";
import {
  formateDate,
  getCustomer,
  ratingAvg1,
  formatMonthDate,
} from "../../include/function";
import "../../styles/ProgressBar.css";
import { useNotification } from "../../Toast/ToastProvider";
import Modal from "../add-ons/Modal";
import Spinner from "../add-ons/Spinner";

const CustomerOrderDetails = () => {
  const { id } = useParams();
  const user = getCustomer();
  const { push } = useNavigate();
  const [fetchLoading, setFetchLoading] = useState(true);
  const [apiConfig, setApiConfig] = useState({});
  const [orderItem, setOrderItem] = useState({});
  const [product, setProduct] = useState({});
  const customer = getCustomer();

  const getApiConfig = () => {
    api
      .get("/config/", customerReqConfig())
      .then((response) => {
        if (response.status === 200) {
          setApiConfig(response.data.data[0]);
        }
      })
      .catch((error) => {});
  };

  const getOrderItem = useCallback(
    (afterGet) => {
      setFetchLoading(true);
      api
        .get(
          "/orders/?orderItemId=" + id + "&customerId=" + user.id,
          customerReqConfig(),
        )
        .then((response) => {
          if (response.status === 200) {
            setOrderItem(response.data.data[0]);
            if (afterGet) afterGet();
          }
        })
        .catch((error) => {
          push("/profile/orders");
        })
        .finally(() => {
          setFetchLoading(false);
        });
    },
    [id, user.id, push],
  );

  useEffect(() => {
    getApiConfig();
  }, []);

  useEffect(() => {
    getApiConfig();
    getOrderItem();
  }, [getOrderItem]);

  useEffect(() => {
    if (orderItem?.productId) {
      getProducts(orderItem.productId);
    }
  }, [orderItem?.productId]);

  const getProducts = async (productId) => {
    console.log("id", productId);
    if (!productId) return;
    setFetchLoading(true);
    const response = await api.get(`/product/?id=${productId}`);
    setProduct(response.data.data[0]);
    setFetchLoading(false);
  };

  const b2bMode = (product.b2bDiscountMode || "").toLowerCase();
  const b2cMode = (product.b2cDiscountMode || "").toLowerCase();
  const safeFloat = (val) => (isNaN(parseFloat(val)) ? 0 : parseFloat(val));

  // Calculate B2B discounted price
  let b2bDiscountUnitPrice = safeFloat(product.price);
  if (b2bMode === "percent") {
    const disc = safeFloat(product.b2bDiscountValue) || 0;
    b2bDiscountUnitPrice =
      safeFloat(product.price) - (safeFloat(product.price) * disc) / 100;
  } else if (b2bMode === "amount") {
    const disc = safeFloat(product.b2bDiscountValue) || 0;
    b2bDiscountUnitPrice = safeFloat(product.price) - disc;
  }

  // Calculate B2C discounted price
  let b2cDiscountUnitPrice = safeFloat(product.price);
  if (b2cMode === "percent") {
    const disc = safeFloat(product.b2cDiscountValue) || 0;
    b2cDiscountUnitPrice =
      safeFloat(product.price) - (safeFloat(product.price) * disc) / 100;
  } else if (b2cMode === "amount") {
    const disc = safeFloat(product.b2cDiscountValue) || 0;
    b2cDiscountUnitPrice = safeFloat(product.price) - disc;
  }

  const isB2C = !customer || customer.customerType === "individual";
  const discountUnitPrice = isB2C ? b2cDiscountUnitPrice : b2bDiscountUnitPrice;
  const subTotal = Math.round(discountUnitPrice).toFixed(2);
  const itemQuantity = (parseFloat(subTotal) * orderItem.qty).toFixed(2);
  const totalPrice = (orderItem.price * orderItem.qty).toFixed(2);
  const discountValue = (totalPrice - itemQuantity).toFixed(2);
  
  return (
    <div className="">
      {/* <div className="position-relative">
            {showModal && <Modal
                component={modalComponent}
                handleClose={setShowModal}
                headerText={modalHeaderText}
                zIndex={1050}
                width="600px"
            />}
        </div> */}
      {fetchLoading ? (
        <div className="py-5">
          <Spinner color="danger" />
        </div>
      ) : (
        <div className="container-fluid  my-4">
          <div className="container " style={{ marginTop: "100px" }}>
            <div className="">
              <nav
                className="d-flex flex-wrap  gap- text-sm text-gray-500 "
                style={{ padding: "30px" }}
              >
                <Link
                  to="/"
                  className="navigation-bar-prc-det transition-colors"
                >
                  Home
                </Link>
                <span className="text-gray-400 select-none">{">"}</span>
                <Link
                  to="/Orders"
                  className="navigation-bar-prc-det transition-colors"
                >
                  My Orders
                </Link>
                <span className="text-gray-400 select-none">{">"}</span>
                <span className="navigation-bar-prc-det  text-gray-400">
                  Order Details
                </span>
              </nav>
            </div>
          </div>

          <div className="row mb-20">
            <div className="col-12 col-lg-9 mb-4">
              <div className="border rounded-16 p-26">
                <div className="container">
                  <h6 className="text-dark fw-bold fs-4">Order Details</h6>
                  <div className="row border rounded-16 p-26 gap-24 mb-24">
                    <div
                      className="bg-gray-100 rounded-8 col-lg-4  d-flex justify-content-center align-items-center"
                      style={{ width: "250px", padding: "20px" }}
                    >
                      <img
                        className="fit-contain w-100 hover-scale"
                        src={
                          orderItem.mainImage &&
                          baseURL + "/" + orderItem.mainImage
                        }
                        alt=""
                        style={{ maxHeight: "200px" }}
                      />
                    </div>
                    <div className="col-lg-8">
                      <div>
                        <h5 className="text-dark fw-bold fs-3 text-capitalize">
                          {orderItem.productName}
                        </h5>
                      </div>
                      <hr className="w-100" />
                      <div className="order-status-time mt-2">
                        {orderItem.createTimestamp && orderItem.status && (
                          <h6 className="text-dark fw-bold fs-5 text-capitalize">
                            <strong>{orderItem.status}</strong> On{" "}
                            {formatMonthDate(orderItem.createTimestamp)}
                          </h6>
                        )}
                      </div>

                      {product?.ratingAndReview?.length > 0 ? (
                        <div className="d-flex align-items-center gap-2">
                          <div
                            className="badge bg-success d-inline-flex text-center"
                            style={{ fontSize: "13px" }}
                          >
                            {ratingAvg1(product.ratingAndReview)}
                            <i className="ph-fill ph-star ms-1" />
                          </div>
                          <span className="fw-medium text-gray-500">
                            ({product.ratingAndReview.length})
                          </span>
                        </div>
                      ) : null}
                      {/* 
                        <h6 className="fw-bold">
                          ₹ {subTotal} / Qty
                        </h6> */}
                    </div>
                    <div className="d-flex justify-content-end align-items-end">
                      <span
                        className=" m-0 text-capitalize"
                        style={{
                          padding: "10px",
                          backgroundColor: "#dbf6e9ff",
                          borderRadius: "8px",
                          color: "#2e5544f9",
                        }}
                      >
                        {orderItem.status}
                      </span>
                    </div>
                  </div>
                  <div className="row border rounded-16 p-26  mt-5 mb-24">
                    <div className="col-12 col-lg-12 mb-4">
                      {/* <div className="border rounded-16 p-26 fs-5">dd */}
                      <h6 className="text-dark fw-bold fs-4">
                        Delivery Details
                      </h6>
                      <hr className="full-width-hr" />

                      <h6 className="text-dark fw-bold">Delivery Address</h6>
                      <div style={{ width: "70%" }}>
                        <p className="text-dark">
                          {orderItem.address}, {orderItem.locality},{" "}
                          {orderItem.city} - {orderItem.pin}, <br />
                          {orderItem.state}
                        </p>
                      </div>

                      {/* </div> */}
                    </div>
                  </div>

                  <div className="row border rounded-16 p-26 ">
                    <div className="col-12 col-lg-12 ">
                      <div className="">
                        <h6 className="text-dark fw-bold">Order Status</h6>
                        <hr className="full-width-hr" />
                        <OrderProgressBar orderItem={orderItem} />
                        {orderItem.cancelledAt ? (
                          <h6 className="mb-4 text-truncate small text-danger">
                            This order has been cancelled.
                          </h6>
                        ) : (
                          <div></div>
                        )}
                      </div>
                    </div>
                  </div>
                  {orderItem.status === "delivered" && (
                    <div className="row border rounded-16 p-26 mt-24">
                      <div className="col-12 col-lg-12 ">
                        <div className="">
                          <h6 className="text-dark fw-bold">
                            Product Rating & Reviews
                          </h6>
                          <hr className="full-width-hr" />
                          <ProductAddRating orderItem={orderItem} />
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="d-flex flex-column justify-content-center align-items-center gap-18 mt-24">
                    <a
                      href="https://api.whatsapp.com/send?phone=7418655526&text=Hi!%20I%20need%20assistance"
                      className="btn btn-outline-orange"
                      style={{
                        border: "2px solid #EF6612",
                        padding: "8px 32px",
                        borderRadius: "5px",
                        fontSize: "14px",
                      }}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span style={{ color: "#EF6612" }}>Chat with us</span>
                    </a>

                    <button
                      className="btn btn-orange"
                      style={{
                        backgroundColor: "#EF6612",
                        color: "white",
                        padding: "9px 16px",
                        borderRadius: "5px",
                        fontSize: "14px",
                      }}
                    >
                      Download invoice
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-3 mb-4">
              <div className="border rounded-16 p-26 fs-5">
                <h6 className="text-dark fw-bold fs-4">Price Details</h6>

                {/* Price */}
                <div
                  style={{
                    padding: "30px",
                    backgroundColor: "#f2f2f2",
                    borderRadius: "8px",
                    marginBottom: "20px",
                  }}
                >
                  <div className="d-flex justify-content-between align-items-center mb-16">
                    <span className="small text-dark">
                      Price ({orderItem.qty}) Items
                    </span>
                    <span className="small fw-bold text-dark">
                      {/* ₹{orderItem.qty*orderItem.price} */}₹{totalPrice}
                    </span>
                  </div>

                  {/* Discount */}
                  <div className="d-flex justify-content-between align-items-center mb-16">
                    <span className="small text-dark">Discount</span>
                    <span className="small fw-bold text-dark">
                      - ₹{discountValue}
                    </span>
                  </div>

                  {/* Coupon Discount */}
                  <div className="d-flex justify-content-between align-items-center mb-16">
                    <span className="small text-dark">Coupon discount</span>
                    <span className="small fw-bold text-dark">- ₹ 0.00</span>
                  </div>

                  {/* Delivery Charge */}
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <span className="small text-dark fw-bold">
                      Delivery Charge
                    </span>
                    <span className="small fw-bold text-dark">
                      ₹{orderItem.deliveryCharge.toFixed(2)}
                    </span>
                  </div>
                </div>
                {/* Total */}
                <div
                  className="d-flex justify-content-between align-items-center"
                  style={{
                    padding: "30px",
                    backgroundColor: "#f2f2f2",
                    borderRadius: "8px",
                    marginTop: "50px",
                    marginBottom: "20px",
                  }}
                >
                  <span className="fw-bold text-dark">Total</span>
                  <span className="fw-bold text-dark">
                    ₹{totalPrice - discountValue + orderItem.deliveryCharge}
                  </span>
                </div>

                {/* Savings */}
                <p className="small text-muted mt-3">
                  You will save ₹{discountValue} on this order.
                </p>
              </div>
              <div style={{ padding: "15px" }}>
                <p className="text-gray-500">
                  Your personal data will be used to process your order, support
                  your experience throughout this website, and for other
                  purposes described in our{" "}
                  <Link
                    to="#"
                    className="text-main-600 text-decoration-underline"
                  >
                    {" "}
                    privacy policy
                  </Link>{" "}
                  .
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const OrderProgressBar = ({ orderItem }) => {
  const steps = [
    { label: ORDERED, date: orderItem.createTimestamp, key: "ordered" },
    { label: PACKED, date: orderItem.packedAt, key: "packed" },
    { label: SHIPPED, date: orderItem.shippedAt, key: "shipped" },
    { label: DELIVERED, date: orderItem.deliveredAt, key: "delivered" },
    {
      label: RETURN_APPROVED,
      date: orderItem.returnApprovedAt,
      key: "return_approved",
    },
    {
      label: RETURN_SHIPPED,
      date: orderItem.returnShippedAt,
      key: "return_shipped",
    },
    {
      label: RETURN_RECEIVED,
      date: orderItem.returnReceivedAt,
      key: "return_received",
    },
    { label: CANCELLED, date: orderItem.cancelledAt, key: "cancelled" },
  ];

  let cutoffKey = "cancelled";

  if (orderItem.status === "delivered") {
    cutoffKey = "delivered";
  } else if (orderItem.status === "cancel request") {
    cutoffKey = orderItem.cancelledAt ? "cancelled" : "return_received";
  }

  const cutoffIndex = steps.findIndex((step) => step.key === cutoffKey);

  const truncatedSteps =
    cutoffIndex >= 0 ? steps.slice(0, cutoffIndex + 1) : steps;

  const visibleSteps = truncatedSteps.filter(
    (step) => step.label === ORDERED || step.date,
  );

  const recentSteps = visibleSteps.slice(-2);

  const allSteps = truncatedSteps;

  const [showModal, setShowModal] = useState(false);

  return (
    <div className="order-tracking-container">
      <div className="d-flex align-items-center mb-24 mt-14 gap-10">
        <div className="order-circle-top-tick-icon">
          <i className="fas fa-check" />
        </div>
        <p
          className="text-dark fw-bold"
          style={{
            padding: "8px",
            backgroundColor: "#D4F2E4",
            borderRadius: "8px",
          }}
        >
          Product Delivered with OTP Verification
        </p>
      </div>

      {/* Main Timeline Wrapper */}
      <div className="order-steps-wrapper">
        {recentSteps.map((step, index) => (
          <div key={index} className="order-step">
            {/* Circle */}
            <div
              className={`order-circle ${
                step.date ? "completed" : "incomplete"
              }`}
            >
              {step.date && <i className="fas fa-check text-white" />}
            </div>

            {/* Line */}
            {index < recentSteps.length - 1 && (
              <div className="order-line"></div>
            )}

            {/* Content */}
            <div className="order-content">
              <div className="d-flex align-items-baseline gap-2">
                <h6 className="fw-bold text-dark fs-5 mb-0">{step.label},</h6>
                {step.date && (
                  <span className="fw-semibold text-dark fs-6">
                    {formateDate(step.date)}
                  </span>
                )}
              </div>
            </div>
          </div>
        ))}
        <span
          className="fw-bold"
          style={{
            color: "#ff680b",
            cursor: "pointer",
          }}
          onClick={() => setShowModal(true)}
        >
          See all updates
        </span>
      </div>

      {showModal && (
        <Modal
          visible={showModal}
          onClose={() => setShowModal(false)}
          size="lg"
          centered={true}
        >
          <div className="order-tracking-container">
            {allSteps.map((step, index) => (
              <div key={index} className="order-step">
                <div
                  className={`order-circle ${
                    step.date ? "completed" : "incomplete"
                  }`}
                >
                  {step.date && <i className="fas fa-check text-white" />}
                </div>

                {index < allSteps.length - 1 && (
                  <div
                    className={`order-line1 ${
                      allSteps[index + 1]?.date ? "" : "incomplete"
                    }`}
                  ></div>
                )}

                <div className="order-content">
                  <h6 className="fw-bold text-dark mb-1 fs-6">
                    {step.label} {step.date && `, ${formateDate(step.date)}`}
                  </h6>
                  <p className="text-dark small mb-0">
                    {step.label === ORDERED && "Your order has been confirmed."}
                    {step.label === PACKED && "Your order has been processed."}
                    {step.label === SHIPPED && "Your order has been shipped."}
                    {step.label === DELIVERED &&
                      "Your order has been delivered."}
                    {step.label === RETURN_APPROVED &&
                      "Your return request has been approved."}
                    {step.label === RETURN_SHIPPED && "Return item shipped."}
                    {step.label === RETURN_RECEIVED && "Return item received."}
                    {step.label === CANCELLED &&
                      "Your order has been cancelled."}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </Modal>
      )}
    </div>
  );
};

const ProductAddRating = ({ orderItem }) => {
  const [rating, setRating] = useState(0);
  const [review, setReview] = useState("");
  const [attachments, setAttachments] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [reviewSubmitted, setReviewSubmitted] = useState(false);
  const [existingReview, setExistingReview] = useState(null);
  const [loadingReview, setLoadingReview] = useState(true);

  const toast = useNotification();
  const user = getCustomer();

  useEffect(() => {
    const fetchExistingReview = async () => {
      try {
        const response = await api.get(
          `/rating_and_review/?customerId=${user.id}&productId=${orderItem.productId}`,
          customerReqConfig(),
        );

        if (response.status === 200 && response.data.data?.length > 0) {
          setExistingReview(response.data.data[0]);
        }
      } catch (error) {
        console.error("Failed to fetch existing review:", error);
      } finally {
        setLoadingReview(false);
      }
    };

    if (user.id && orderItem.productId) {
      fetchExistingReview();
    }
  }, [user.id, orderItem.productId]);

  if (orderItem.status !== "delivered") {
    return null;
  }

  if (loadingReview) {
    return <div className="text-center py-4">Loading...</div>;
  }

  // Show existing review if found
  if (existingReview) {
    return (
      <div className="mt-4 p-4 bg-light rounded-16 text-center">
        <h6 className="text-dark fw-bold mb-3">
          You already reviewed this product!
        </h6>
        <div className="d-flex justify-content-center gap-1">
          {[...Array(5)].map((_, i) => (
            <i
              key={i}
              className={`fas fa-star fs-4 ${
                i < existingReview.rating ? "text-warning" : "text-muted"
              }`}
            ></i>
          ))}
        </div>
        {existingReview.review && (
          <p className="mt-2 text-muted small">"{existingReview.review}"</p>
        )}
        <p className="mt-1 text-muted small">
          Rated on{" "}
          {new Date(existingReview.createTimestamp).toLocaleDateString()}
        </p>
      </div>
    );
  }

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    const newFiles = files.map((file) => ({
      file,
      previewUrl: URL.createObjectURL(file),
      isVideo: file.type.startsWith("video/"),
    }));
    setAttachments((prev) => [...prev, ...newFiles]);
  };

  const removeFile = (indexToRemove) => {
    setAttachments((prev) => {
      const removed = prev[indexToRemove];
      if (removed) URL.revokeObjectURL(removed.previewUrl);
      return prev.filter((_, index) => index !== indexToRemove);
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!rating) {
      toast({ type: ERROR, message: "Please select a rating." });
      return;
    }

    const formData = new FormData();
    formData.append("customerId", user.id);
    formData.append("productId", orderItem.productId);
    formData.append("rating", rating);
    formData.append("review", review);

    attachments.forEach(({ file }) => {
      formData.append("attachmentUrl[]", file);
    });

    setIsSubmitting(true);

    try {
      const response = await api.post("/rating_and_review/", formData, {
        ...customerReqConfig(),
        headers: {
          ...customerReqConfig().headers,
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.status === 200 || response.status === 201) {
        toast({ type: SUCCESS, message: "Thank you for your review!" });
        setReviewSubmitted(true);

        const updatedResponse = await api.get(
          `/rating_and_review/?customerId=${user.id}&productId=${orderItem.productId}`,
          customerReqConfig(),
        );
        if (updatedResponse.data.data?.length > 0) {
          setExistingReview(updatedResponse.data.data[0]);
        }
      }
    } catch (error) {
      toast({
        type: ERROR,
        message: error.response?.data?.message || "Failed to submit review.",
      });
    } finally {
      setIsSubmitting(false);
      attachments.forEach((item) => URL.revokeObjectURL(item.previewUrl));
    }
  };

  return (
    <div className="mt-4">
      {reviewSubmitted ? (
        <div className="p-4 bg-light rounded-16 text-center">
          <h6 className="text-dark fw-bold mb-3">Thank you for your review!</h6>
          <div className="d-flex justify-content-center gap-1">
            {[...Array(5)].map((_, i) => (
              <i
                key={i}
                className={`fas fa-star fs-4 ${
                  i < rating ? "text-warning" : "text-muted"
                }`}
              ></i>
            ))}
          </div>
          <p className="mt-2 text-muted small">
            You rated this product {rating} out of 5 stars.
          </p>
        </div>
      ) : (
        <form onSubmit={handleSubmit}>
          {/* Rating Stars */}
          <div className="mb-3">
            <label className="form-label text-dark fw-bold fs-5">
              Your ratings:
            </label>
            <div className="d-flex gap-18 mt-14 mb-9">
              {[...Array(5)].map((_, i) => (
                <span
                  key={i}
                  className={`cursor-pointer ${
                    i < rating ? "text-warning" : "text-gray-300"
                  }`}
                  onClick={() => setRating(i + 1)}
                >
                  <i className="fas fa-star fs-3"></i>
                </span>
              ))}
            </div>
          </div>

          {/* Write Review */}
          <div className="mb-3 mt-24">
            <label className="form-label text-dark fw-bold fs-5">
              Write review
            </label>
            <textarea
              className="form-control mt-14"
              rows="4"
              placeholder="Enter your reviews here..."
              value={review}
              onChange={(e) => setReview(e.target.value)}
              style={{ resize: "none" }}
              required
            ></textarea>
          </div>

          {/* Add Photos/Videos */}
          <div className="mb-4 mt-24">
            <label className="form-label text-dark fw-bold fs-5">
              Add photos / Videos
            </label>
            <div className="d-flex gap-10 mt-2 align-items-center">
              <input
                type="file"
                id="photo-upload"
                multiple
                accept="image/*,video/*"
                onChange={handleFileChange}
                style={{ display: "none" }}
              />
              <label
                htmlFor="photo-upload"
                className="btn rounded-5 cursor-pointer d-flex align-items-center justify-content-center"
                style={{
                  width: "60px",
                  height: "60px",
                  border: "2px solid #e8e8e8",
                  backgroundColor: "#fafafa",
                }}
              >
                <i
                  className="fas fa-camera"
                  style={{ color: "#808080", fontSize: "28px" }}
                ></i>
              </label>

              <label
                htmlFor="photo-upload"
                className="btn rounded-5 cursor-pointer d-flex align-items-center justify-content-center"
                style={{
                  width: "60px",
                  height: "60px",
                  border: "2px solid #e8e8e8",
                  backgroundColor: "#fafafa",
                }}
              >
                <i
                  className="fas fa-video"
                  style={{ color: "#808080", fontSize: "28px" }}
                ></i>
              </label>
            </div>

            {/* PREVIEWS ROW */}
            {attachments.length > 0 && (
              <div className="mt-3">
                <div
                  className="d-flex gap-2 overflow-x-auto py-2"
                  style={{ scrollbarWidth: "none" }}
                >
                  {attachments.map((item, index) => (
                    <div
                      key={index}
                      className="position-relative flex-shrink-0"
                      style={{ width: "80px", height: "80px" }}
                    >
                      {item.isVideo ? (
                        <video
                          src={item.previewUrl}
                          className="w-100 h-100 object-fit-fill rounded-8"
                          style={{ background: "#000" }}
                        />
                      ) : (
                        <img
                          src={item.previewUrl}
                          alt={`preview-${index}`}
                          className="w-100 h-100 object-fit-fill rounded-8"
                        />
                      )}

                      {item.isVideo && (
                        <div className="position-absolute top-50 start-50 translate-middle text-white">
                          <i
                            className="fas fa-play-circle"
                            style={{ fontSize: "24px" }}
                          ></i>
                        </div>
                      )}

                      <button
                        type="button"
                        className="btn btn-sm btn-outline-danger position-absolute top-0 end-0 m-1"
                        style={{
                          width: "20px",
                          height: "20px",
                          padding: 0,
                          borderRadius: "50%",
                          border: "none",
                          backgroundColor: "rgba(255, 0, 0, 0.8)",
                          color: "white",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          zIndex: 10,
                        }}
                        onClick={() => removeFile(index)}
                      >
                        <i
                          className="fas fa-times"
                          style={{ fontSize: "10px" }}
                        ></i>
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* Buttons */}
          <div className="d-flex gap-18 mt-24">
            <button
              type="button"
              className="btn rounded-5"
              style={{ backgroundColor: "#f2f2f2" }}
              onClick={() => {
                console.log("Skipped review");
              }}
            >
              <span className="text-dark fw-bold">Skip & Finish</span>
            </button>
            <button
              type="submit"
              className="btn rounded-5"
              style={{ backgroundColor: "#fa6403", color: "white" }}
              disabled={isSubmitting}
            >
              <span className="fw-bold">
                {isSubmitting ? "Submitting..." : "\u00A0 Submit \u00A0"}
              </span>
            </button>
          </div>
        </form>
      )}
    </div>
  );
};

export default CustomerOrderDetails;
